/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/guiPublications/guiPublicationsActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { GuiPublicationEditForm } from "./GuiPublicationEditForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { KTUtil } from "../../../../../../_metronic/_assets/js/components/util";
import KTLayoutQuickForm from "../../../../Admin/utils/quick-form";
import {GuideProfile} from "../../profile/GuideProfile";
import axios from "axios";

const initGuiPublication = {
  id: undefined,
  guideId: 0,
  category: "",
  publicationTitle: "",
  link: "",
  publishedDate: "2020-10-17T04:45:42.438Z",
  publishLocation: "",
  remark: "",
  uplaodFile: "",
};
export function GuiPublicationEdit({
  history,
  match: {
    params: { id,gid},
  },
}) {
  useLayoutEffect(() => {
    KTUtil.ready(function() {
      KTLayoutQuickForm.init("kt_quick_form");
    });
  }, []);
  // Subheader
  const subheader = useSubheader();

  // Tabs
  // const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, guiPublicationForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.guiPublications.actionsLoading,
      guiPublicationForEdit: state.guiPublications.guiPublicationForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchGuiPublication(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Guide Publication";
    if (guiPublicationForEdit && id) {
      _title = `Edit Guide Publication`;
    }

    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guiPublicationForEdit, id]);

  const saveGuiPublication = (values) => {
    if (!id) {
      dispatch(actions.createGuiPublication(values)).then(() =>
        backToGuiPublicationsList()
      );
    } else {
      dispatch(actions.updateGuiPublication(values)).then(() =>
        backToGuiPublicationsList()
      );
    }
  };

  const btnRef = useRef();
  const saveGuiPublicationClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };
  const id1 = id===undefined?'':id
  const GuideUrl = `${process.env.REACT_APP_API_URL}/api/guiPublication/${id1}`;

  const [guide, setGuide] = useState([]);

  useEffect(() => {
    const getGuide = async () => {
      const response = await axios.get(GuideUrl);
      setGuide(response.data);
    };
    getGuide();
  }, [setGuide,GuideUrl]);


  const GuideId = gid?gid:guide.guideId;
  initGuiPublication.guideId=GuideId;


  const backToGuiPublicationsList = () => {
    history.push(`/guide/guideprofile`);
  };

  return (
    <div>
      <GuideProfile />
      <div
        id="kt_quick_form"
        className="offcanvas offcanvas-right offcanvas offcanvas-on offcanvas-sm"
      >
        <div className="offcanvas-content pr-5 mr-n5">
          <Card>
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}>
              <CardHeaderToolbar>
                <button
                  type="button"
                  onClick={backToGuiPublicationsList}
                  className="btn btn-light"
                >
                  <i className="fa fa-times"></i>
                  Close
                </button>
                {/* <button className="btn btn-light ml-2">
                    <i className="fa fa-redo"></i>
                    Reset
                  </button> */}
                <button
                  type="submit"
                  className="btn btn-primary ml-2"
                  onClick={saveGuiPublicationClick}
                >
                  Save
                </button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              {!actionsLoading && (
                <GuiPublicationEditForm
                  actionsLoading={actionsLoading}
                  guiPublication={guiPublicationForEdit || initGuiPublication}
                  btnRef={btnRef}
                  saveGuiPublication={saveGuiPublication}
                />
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
